import React, { useEffect, useState } from 'react';
import { isletmeApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const ILLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Aksaray','Amasya','Ankara','Antalya','Ardahan','Artvin','Aydın','Balıkesir','Bartın','Batman','Bayburt','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Düzce','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Iğdır','Isparta','İstanbul','İzmir','Kahramanmaraş','Karabük','Karaman','Kars','Kastamonu','Kayseri','Kırıkkale','Kırklareli','Kırşehir','Kilis','Kocaeli','Konya','Kütahya','Malatya','Manisa','Mardin','Mersin','Muğla','Muş','Nevşehir','Niğde','Ordu','Osmaniye','Rize','Sakarya','Samsun','Şanlıurfa','Siirt','Sinop','Şırnak','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Uşak','Van','Yalova','Yozgat','Zonguldak'];

export default function Isletmeler() {
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [isletmeTipleri, setIsletmeTipleri] = useState<string[]>([]);
  const [arama, setArama] = useState('');
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState<any>({});
  const [hata, setHata] = useState('');

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  const yukle = () => isletmeApi.list().then(r => setIsletmeler(r.data));

  const yukleIsletmeTipleri = async () => {
    try {
      const r = await fetch(`${API}/api/tanimlar2/liste?ust=O.1.2.1&sadece_yaprak=true`, { headers: hdr() });
      if (r.ok) {
        const data = await r.json();
        setIsletmeTipleri(data.map((d: any) => d.ad));
      }
    } catch {}
  };

  useEffect(() => { yukle(); yukleIsletmeTipleri(); }, []);

  const filtreli = isletmeler.filter(i =>
    i.ad.toLowerCase().includes(arama.toLowerCase()) ||
    i.kod.toLowerCase().includes(arama.toLowerCase()) ||
    (i.il || '').toLowerCase().includes(arama.toLowerCase())
  );

  const gruplar = ['Faal', ...isletmeTipleri.filter(t => t !== 'Faal'), 'Diğer'];

  const yeniAc = () => { setSecili(null); setForm({ tip: 'Faal' }); setHata(''); setModalAcik(true); };
  const duzenleAc = (i: any) => { setSecili(i); setForm({...i}); setHata(''); setModalAcik(true); };
  const kapat = () => { setModalAcik(false); setSecili(null); setForm({}); setHata(''); };

  const kaydet = async () => {
    setHata('');
    if (!form.kod?.trim()) { setHata('Kod zorunludur'); return; }
    if (!form.ad?.trim()) { setHata('İşletme adı zorunludur'); return; }
    const kodUpper = form.kod.trim().toUpperCase();
    const mukerrer = isletmeler.find(i =>
      i.kod.toUpperCase() === kodUpper && (!secili || i.id !== secili.id)
    );
    if (mukerrer) { setHata(`'${kodUpper}' kodu zaten kullanımda: ${mukerrer.ad}`); return; }
    try {
      if (secili) await isletmeApi.update(secili.id, { ...form, kod: kodUpper });
      else await isletmeApi.create({ ...form, kod: kodUpper });
      yukle(); kapat();
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Bir hata oluştu');
    }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu işletmeyi pasif yapmak istediğinizden emin misiniz?')) return;
    await isletmeApi.delete(id); yukle();
  };

  const grupIsletmeleri = (tip: string) => {
    if (tip === 'Diğer') return filtreli.filter(i => !i.tip || !isletmeTipleri.includes(i.tip));
    return filtreli.filter(i => i.tip === tip);
  };

  const GRUP_RENK: Record<string, string> = {
    'Faal': '#1e8449',
    'Kiralık': '#1a5276',
    'Merkez': '#6c3483',
  };

  return (
    <div>
      <div className="page-header">
        <h1>🏢 İşletme Yönetimi</h1>
        <p>TİGEM'e bağlı tarım işletmelerinin yönetimi</p>
      </div>

      <div className="card">
        <div className="toolbar">
          <input className="search-input" placeholder="Ara (ad, kod, il)..." value={arama} onChange={e => setArama(e.target.value)} />
          {isAdmin && <button className="btn btn-success" onClick={yeniAc}>+ Yeni İşletme</button>}
        </div>

        {gruplar.map(tip => {
          const liste = grupIsletmeleri(tip);
          if (liste.length === 0) return null;
          const renk = GRUP_RENK[tip] || '#555';
          return (
            <div key={tip} style={{ marginBottom: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, padding: '6px 12px', background: renk, borderRadius: 6 }}>
                <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
                  {tip === 'Faal' ? '🟢' : tip === 'Kiralık' ? '🔵' : '🟣'} {tip} İşletmeler
                </span>
                <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>{liste.length} işletme</span>
              </div>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Kod</th><th>İşletme Adı</th><th>İl</th><th>İlçe</th>
                      <th>Müdür</th><th>Telefon</th><th>Durum</th>
                      {isAdmin && <th>İşlem</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {liste.map(i => (
                      <tr key={i.id}>
                        <td><strong>{i.kod}</strong></td>
                        <td>{i.ad}</td>
                        <td>{i.il}</td>
                        <td>{i.ilce || '-'}</td>
                        <td>{i.mudur || '-'}</td>
                        <td>{i.telefon || '-'}</td>
                        <td><span className={`badge badge-${i.aktif ? 'aktif' : 'pasif'}`}>{i.aktif ? 'Aktif' : 'Pasif'}</span></td>
                        {isAdmin && (
                          <td>
                            <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(i)} style={{marginRight:4}}>Düzenle</button>
                            <button className="btn btn-danger btn-sm" onClick={() => sil(i.id)}>Pasif</button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}

        {filtreli.length === 0 && (
          <div style={{ textAlign: 'center', color: '#999', padding: 20 }}>Kayıt bulunamadı</div>
        )}
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={kapat}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{secili ? 'İşletme Düzenle' : 'Yeni İşletme'}</h3>
              <button className="modal-close" onClick={kapat}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                <div className="form-group">
                  <label>Kod *</label>
                  <input className="form-control" value={form.kod||''} onChange={e=>setForm({...form,kod:e.target.value})} placeholder="Örn: ADA" />
                </div>
                <div className="form-group">
                  <label>İl *</label>
                  <select className="form-control" value={form.il||''} onChange={e=>setForm({...form,il:e.target.value})}>
                    <option value="">Seçiniz</option>
                    {ILLER.map(il => <option key={il} value={il}>{il}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>İşletme Adı *</label>
                <input className="form-control" value={form.ad||''} onChange={e=>setForm({...form,ad:e.target.value})} placeholder="İşletme adı" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>İlçe</label>
                  <input className="form-control" value={form.ilce||''} onChange={e=>setForm({...form,ilce:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>İşletme Türü</label>
                  <select className="form-control" value={form.tip||'Faal'} onChange={e=>setForm({...form,tip:e.target.value})}>
                    {isletmeTipleri.length > 0
                      ? isletmeTipleri.map(t => <option key={t} value={t}>{t}</option>)
                      : <option value="Faal">Faal</option>
                    }
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Müdür</label>
                  <input className="form-control" value={form.mudur||''} onChange={e=>setForm({...form,mudur:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Telefon</label>
                  <input className="form-control" value={form.telefon||''} onChange={e=>setForm({...form,telefon:e.target.value})} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>E-posta</label>
                  <input className="form-control" value={form.email||''} onChange={e=>setForm({...form,email:e.target.value})} />
                </div>
              </div>
              <div className="form-group">
                <label>Adres</label>
                <textarea className="form-control" value={form.adres||''} onChange={e=>setForm({...form,adres:e.target.value})} rows={2} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={kapat} style={{background:'#eee'}}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
